import React from 'react';
import { Accessory } from '@upstart/harmony/lib/legos/accessoryTypes';
import { fmtMoney } from '@upstart/harmony/lib/formatter';
import { getAccessoryPrice } from '@upstart/harmony/lib/accessory-utils';
import Input from '../Input';

interface Props {
  fetching?: boolean;
  accessories?: Accessory[];
  selectedAccessories?: Accessory[];
  toggleAccessory: (accessory: Accessory) => void;
  disabled?: boolean;
}

function AccessoryList(props: Props) {
  return (
    <div className="protection-plans-modal-products">
      {!props.fetching && props.accessories?.length === 0 && (
        <div className="text-center">No accessories available</div>
      )}
      {props.accessories?.map(accessory => (
        <div key={accessory.id} className="protection-plans-modal-product">
          <Input
            type="checkbox"
            checked={props.selectedAccessories?.some(
              a => a.id === accessory.id,
            )}
            className="protection-plans-modal-check"
            onChange={() => props.toggleAccessory(accessory)}
            disabled={!!props.disabled}
          />
          <div className="protection-plans-modal-product-name">
            {accessory.name}
          </div>
          <div className="protection-plans-modal-product-price">
            {fmtMoney(getAccessoryPrice(accessory))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AccessoryList;
